<template>
  <div>
    <div class="searchBox">
      <div class="searchLeft">
        <el-input
          size="medium"
          v-model="searchForm.sysUserId"
          type="text" @input="searchForm.sysUserId = String(searchForm.sysUserId).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"
          placeholder="请输入用户ID"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-input
          size="medium"
          v-model="searchForm.userName"
          placeholder="请输入用户姓名"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-input
          size="medium"
          v-model="searchForm.email"
          placeholder="请输入邮箱"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-select
          size="medium"
          v-model="searchForm.auditStatus"
          placeholder="请选择状态"
          @change="getTableList"
          clearable 
        >
          <el-option
            v-for="item in stateOptions"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
        size="medium"
          v-model="searchForm.startTime"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsStart"
          placeholder="请选择开始时间">
        </el-date-picker>
        <el-date-picker
          size="medium"
          v-model="searchForm.endTime"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsEnd"
          placeholder="请选择结束时间">
        </el-date-picker>
        <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      </div>
      <div class="searchRight">
        <!-- <el-button size="medium" type="warning" @click="getData"><i class="el-icon-setting" style="margin-right:5px;"></i>提现参数设置</el-button> -->
      </div>
    </div>
    <el-table
      border
      :data="tableData"
      height="73vh"
      style="width: 100%">
      <el-table-column
        prop="createTime"
        label="提交时间">
        <template slot-scope="scope">
          <span>{{$selfFunc.dayjsFunc(scope.row.createTime)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="80px"
        prop="sysUserId"
        label="用户ID">
      </el-table-column>
      <el-table-column
        width="80px"
        prop="userName"
        label="用户姓名">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="电话">
      </el-table-column>
      <el-table-column
        prop="email"
        label="邮箱">
      </el-table-column>
      <el-table-column
        prop="country"
        label="国家">
      </el-table-column>
      <el-table-column
        prop="idNo"
        label="证件号码">
      </el-table-column>
      <el-table-column
        prop="sex"
        width="80px"
        label="性别">
        <template slot-scope="scope">
          <span>{{scope.row.sex==1?'男':'女'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="dueDate"
        label="到期时间">
      </el-table-column>
      <el-table-column
        prop="frontPhoto"
        label="正面照">
        <template slot-scope="scope">
          <el-popover placement="bottom" trigger="click"> <!--trigger属性值：hover、click、focus 和 manual-->
            <a :href="scope.row.frontPhoto" target="_blank" title="查看最大化图片">
              <img :src="scope.row.frontPhoto" style="width: 600px;height: 500px">
            </a>
            <img slot="reference" :src="scope.row.frontPhoto" style="width: 100px;height: 50px; cursor:pointer" />
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="backPhoto"
        label="反面照">
        <template slot-scope="scope">
          <el-popover placement="bottom" trigger="click"> <!--trigger属性值：hover、click、focus 和 manual-->
            <a :href="scope.row.backPhoto" target="_blank" title="查看最大化图片">
              <img :src="scope.row.backPhoto" style="width: 600px;height: 500px">
            </a>
            <img slot="reference" :src="scope.row.backPhoto" style="width: 100px;height: 50px; cursor:pointer" />
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="holdCardPhoto"
        label="手持证件照">
        <template slot-scope="scope">
          <el-popover placement="bottom" trigger="click"> <!--trigger属性值：hover、click、focus 和 manual-->
            <a :href="scope.row.holdCardPhoto" target="_blank" title="查看最大化图片">
              <img :src="scope.row.holdCardPhoto" style="width: 600px;height: 500px">
            </a>
            <img slot="reference" :src="scope.row.holdCardPhoto" style="width: 100px;height: 50px; cursor:pointer" />
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="passportPhoto"
        label="护照照片">
        <template slot-scope="scope">
          <el-popover placement="bottom" trigger="click" v-if="scope.row.passportPhoto">
            <a :href="scope.row.passportPhoto" target="_blank" title="查看最大化图片">
              <img :src="scope.row.passportPhoto" style="width: 600px;height: 500px">
            </a>
            <img slot="reference" :src="scope.row.passportPhoto" style="width: 100px;height: 50px; cursor:pointer" />
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="way"
        fixed="right"
        width="150px"
        label="操作">
        <template slot-scope="scope">
          <div v-if="scope.row.auditStatus==0">
            <el-button size="mini" type="primary" @click="upData(scope.row.id,1)"><i class="el-icon-edit" style="margin-right:3px;"></i>通过</el-button>
            <el-button size="mini" type="danger"  @click="refuse(scope.row.id,2)"><i class="el-icon-delete" style="margin-right:3px;"></i>拒绝</el-button>
          </div>
          <div v-else-if="scope.row.auditStatus==1" style="color:#0da93d;font-weight:bold">已通过</div>
          <div v-else-if="scope.row.auditStatus==2" style="color:#F56C6C;font-weight:bold">已拒绝</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox" v-if="totalNum > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchForm.page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        >
        </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error('输入不能为空'));
      }else {
        if (value !=parseInt(value)) {
          callback(new Error('输入必须为正整数'));
        } else if (value < 0) {
          callback(new Error('输入不能为负值'));
        } else {
          callback();
        }
      }
    };
    var checkNum1 = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error("请输入正确的数值"));
      } else if (value <= 0) {
        callback("输入必须为正数");
      }else {
        callback()
      }
    };
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime()
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000)
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:10,
        sysUserId: '',
        userName: '',
        invitationCode: '',
        email:'',
        startTime:'',
        endTime:'',
        auditStatus: ''
      },
      tableData: [],
      stateOptions: [
        { name: "待审核", value: 0 },
        { name: "已通过", value: 1 },
        { name: "已拒绝", value: 2 },
      ],
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    refuse(id,type) {
      this.$prompt('请输入拒绝原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async ({ value }) => {
        let res = await this.$http.sysUserAudit({id:id,auditStatus:type,rejectReason:value});
        if (res) {
          this.$message({
            type: 'success',
            message: '操作成功'
          });
          this.getTableList()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });       
      });
    },
    upData(id,type) {
      let mag
      if (type == 1) {
        mag = '此操作将认证通过, 是否继续？'
      } else{
        mag = '此操作将拒绝通过, 是否继续？'

      }
      this.$confirm(mag, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await this.$http.sysUserAudit({id:id,auditStatus:type});
        if (res) {
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.getTableList()
        }
        
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
      let res = await this.$http.sysUserAuthList({...this.searchForm});
      if (res) {
        this.tableData=res.data.list
        this.totalNum=Number(res.data.totalSize)
      }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
.txt_2{
  margin-bottom: 10px;
}
.txt_3{
  display: inline-block;
  width: 160px;
}
.txt_3:first-child{
  margin-right: 20px;
}
.imgBox{
  width: 200px;
  height: 40px;
}
</style>
<style>
.nodeModules .el-dialog__body{
  padding:0  20px  20px;
}
.nodeModules .el-radio{
  width: 100%;
  margin-bottom: 20px;
}
</style>
